const http = {
  OK: 'success'
}

export default (Vue) => {
  Vue.prototype.http = http

  Vue.http = http
}



// WEBPACK FOOTER //
// ./src/util/httpCode.js